import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Column, Row } from '../common/GridLayout/GridLayout';
import { rtl } from '../../utils/language';
import { titleStyles } from '../common/styles';

const Content = styled.div``;

const Title = styled.div.attrs(({ className }) => ({ className }))`
  font-size: 20px;
  letter-spacing: -0.12px;
  margin-bottom: 15px;

  ${titleStyles} ${rtl`
    font-family: Tajawal;
  `};
`;

const AssignmentSection = ({ title, children }) => (
  <Row>
    <Column colSpan="col-12 col-lg-2">
      <Title>{title}</Title>
    </Column>
    <Column colSpan="col-12 col-lg-6">
      <Content className="alef-assignment-form-section">{children}</Content>
    </Column>
  </Row>
);

AssignmentSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  style: PropTypes.object,
};

AssignmentSection.defaultProps = {
  style: {},
};

export default AssignmentSection;
